export enum LocalStorageKey {
    Unknown,
    AuthToken = "auth_token",
    AuthUsername = "auth_username",
    AuthTempSession = "auth_temp_session",
    SessionId = "auth_session_id",
    EmailAddress = "email_address",
    ActiveGameSelection = "active_game",
    PreviewItemControlsVisibility = "preview_controls",
    RoleAndPermissions = "role_and_permissions",
    DisplayName = "display_name",
    GlobalNotificationStore = "global_notification_store"
}

export function getFromLocalStorage(key: string, defaultValue?: string | undefined): string | undefined {
    var result = localStorage.getItem(key);

    if (!result || (result === "undefined")) {
        return defaultValue;
    } else {
        return result;
    }
}

export function getFromSessionStorage(key: string, defaultValue?: string | undefined): string | undefined {
    var result = sessionStorage.getItem(key);

    if (!result || (result === "undefined")) {
        return defaultValue;
    } else {
        return result;
    }
}